import { Injectable } from '@angular/core';
import { Credentials, IAuthStrategy, Token } from '../interfaces/auth-strategy.interface';
import { of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AdapterAuthStrategyService implements IAuthStrategy {

  constructor() { }

  login(credentials: Credentials<Token>) {
    console.log(credentials.data.token);
    return of('adapter');
  }
}
